import { type ScannerProfileType, type ModelsConfigType, type ScannerProfilesType, DecisionMode } from './tenant-configuration';

// https://github.com/barcoemu/tig-pat-research-notebooks/blob/master/wsi/roi_per_scanner_type.ipynb
// Updating this list impacts onboarding and scanners listed in the frontend. Be careful when making changes.
export const supportedScannerProfilesDefaults: Record<string, ScannerProfileType> = {
  'gt450': {
    name: 'GT450',
    vendor: 'Leica',
    offset: {
      left: 11.0,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'at2': {
    name: 'AT2',
    vendor: 'Leica',
    offset: {
      left: 5.5,
      right: 3.5,
      top: 0.6,
      bottom: 0.6,
    },
  },
  'c13220': {
    name: 'C13220', // aka NanoZoomer S360
    vendor: 'Hamamatsu',
    offset: {
      left: 22.5, // label is not part of the macro
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'c13210': {
    name: 'C13210', // aka NanoZoomer S60
    vendor: 'Hamamatsu',
    offset: {
      left: 22.5, // label is not part of the macro
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'ventana dp 200': {
    name: 'DP200',
    vendor: 'Ventana',
    offset: {
      left: 22.5,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'ventana dp 600': {
    name: 'DP600',
    vendor: 'Ventana',
    offset: {
      left: 22.5,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'pannoramic scan 150': {
    name: 'Pannoramic SCAN 150',
    vendor: '3DHISTECH',
    offset: {
      left: 0.3,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'pannoramic 250': {
    name: 'Pannoramic 250',
    vendor: '3DHISTECH',
    offset: {
      left: 0.3,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'pannoramic 1000': {
    name: 'Pannoramic 1000',
    vendor: '3DHISTECH',
    offset: {
      left: 0.3,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
};

export const defaultScannerProfile: ScannerProfileType = {
  name: 'Default',
  vendor: 'Barco',
  offset: {
    left: 11.0,
    right: 0.3,
    top: 0.3,
    bottom: 0.3,
  },
};

export const scannerProfilesDefaults: ScannerProfilesType = {
  default: defaultScannerProfile,
  ...supportedScannerProfilesDefaults,
};

export const defaultModelsConfig: ModelsConfigType = {
  schema_version: '1.2.0',
  detection: {
    scannerProfiles: {
      default: defaultScannerProfile,
    },
  },
  interpretation: {
    blur: {
      lowerThreshold: 0.08,
      upperThreshold: 0.30,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    missingTissue: {
      lowerThreshold: 0.2,
      upperThreshold: 1,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    misalignedCoverSlip: {
      lowerThreshold: 0.2,
      upperThreshold: 40,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    cutOffTissue: {
      lowerThreshold: 0.4,
      upperThreshold: 40,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    markerOnTopOfTissue: {
      lowerThreshold: 0.1,
      upperThreshold: 10,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    imageDataLoss: {
      aggregatedAs: 'RED',
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      automaticRescan: false,
      excluded: false,
    },
    striping: {
      lowerThreshold: 0.35,
      upperThreshold: 0.5,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
  },
};
